import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

async function checkAddPageGuard(to: Route, from: Route, next: NavigationGuardNext) {
  const isFacebook = store.getters['auth/isFacebook']
  const pages = await store.dispatch('pages/GET_PAGES')
  // const accounts = await store.dispatch('instagram/GET_ACCOUNTS')
  if (isFacebook && !pages) {
    return next()
  }
  return next()
}

export default checkAddPageGuard
